import { Theme } from '@mui/material/styles';
import { SystemStyleObject } from '@mui/system';

const floatingInputSx = (theme: Theme): SystemStyleObject<Theme> => ({
  '& input:focus, & textarea:focus': {
    outline: 0,
    boxShadow: 'none',
  },
  position: 'relative',
  width: '100%',
  paddingBottom: 0,
  lineHeight: 1.4,
  boxSizing: 'border-box',
  marginBottom: '20px',
  '@supports (-webkit-appearance: none)': {
    '& .MuiOutlinedInput-notchedOutline legend': { visibility: 'visible !important' },
  },
  '& .MuiFormControl-root': { marginBottom: 0 },
  '& .MuiFormLabel-asterisk': { opacity: 0 },
  '& .MuiOutlinedInput-root': {
    minHeight: '38px',
    '& .MuiOutlinedInput-input': { padding: '8px 16px' },
    '&.MuiInputBase-multiline': {
      padding: 0,
      '& textarea.MuiOutlinedInput-input': { minHeight: 'unset', resize: 'vertical' },
    },
    '&:hover fieldset, &.Mui-focused fieldset': { borderColor: 'primary.main' },
    '&.Mui-error fieldset, &.Mui-focused.Mui-error fieldset': { borderColor: 'error.main' },
    '&.Mui-disabled': {
      backgroundColor: `color-mix(in srgb, ${
        theme.palette.common.inputDisabledBackground || theme.palette.action.disabledBackground
      } 38%, transparent)`,
      '& .MuiOutlinedInput-input': {
        cursor: 'not-allowed',
        WebkitTextFillColor: theme.palette.text.secondary,
      },
      '& fieldset, &:hover fieldset': {
        borderColor: 'action.disabled',
        borderWidth: '1px',
      },
    },
  },
  '& .MuiInputLabel-root': {
    color: 'text.secondary',
    overflow: 'hidden',
    '&.Mui-focused': { color: 'primary.main' },
    '&.Mui-error': { color: 'error.main' },
    '& .input-tooltip-icon': {
      fontSize: '14px !important',
      verticalAlign: 'middle',
      marginLeft: '4px',
      '&:first-of-type': { transform: 'translateY(-1px)', pointerEvents: 'all' },
    },
  },
  '& .floating-label-input__tooltip': {
    display: 'flex',
    alignItems: 'center',
    marginTop: '4px',
  },
  '& input:-webkit-autofill': {
    boxShadow: `0 0 0 1000px ${theme.palette.background.paper} inset`,
    WebkitTextFillColor: 'inherit',
    transition: 'background-color 9999s ease-out, color 9999s ease-out',
  },
});

export default floatingInputSx;
